import React, { FC, ReactNode } from 'react';

import getClassName from 'src/common/utils/getClassName';
import s from './ToggleDecorator.module.scss';

type ToggleDecoratorProps = {
  children: ReactNode;
  className?: string;
  classNameModifier?: string;
};

const ToggleDecorator: FC<ToggleDecoratorProps> = ({
  children,
  className = '',
  classNameModifier,
}) => (
  <span className={`${getClassName(s, 'root', classNameModifier)} ${className}`.trim()}>
    {children}
    <span className={s.thumb} />
  </span>
);

export default ToggleDecorator;
